export const SkeletonFilters = () => (
  <div className="mb-6 bg-white shadow-lg rounded-xl p-6 border-t-4 border-red-500 animate-pulse">
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div>
        <div className="h-4 bg-gray-200 rounded w-24 mb-2"></div>
        <div className="h-10 bg-gray-200 rounded"></div>
      </div>
      <div>
        <div className="h-4 bg-gray-200 rounded w-32 mb-2"></div>
        <div className="h-10 bg-gray-200 rounded"></div>
      </div>
      <div className="self-end">
        <div className="h-10 bg-gray-200 rounded"></div>
      </div>
    </div>
  </div>
);

export const SkeletonInfoBanner = () => (
  <section className="mb-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 animate-pulse">
    {[...Array(3)].map((_, i) => (
      <div key={i} className="bg-white shadow-lg rounded-xl p-6 border-t-4 border-gray-300">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <div className="h-3 bg-gray-200 rounded w-32 mb-3"></div>
            <div className="h-8 bg-gray-200 rounded w-16"></div>
          </div>
          <div className="bg-gray-100 p-4 rounded-xl">
            <div className="w-8 h-8 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>
    ))}
  </section>
);

export const SkeletonClientesTable = () => (
  <div className="bg-white shadow-lg rounded-xl overflow-hidden animate-pulse">
    <div className="overflow-x-auto">
      <table className="min-w-full">
        <thead>
          <tr className="bg-gray-50 border-b border-gray-200">
            {[...Array(8)].map((_, i) => (
              <th key={i} className="py-4 px-6">
                <div className="h-4 bg-gray-200 rounded"></div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {[...Array(5)].map((_, rowIndex) => (
            <tr key={rowIndex} className="border-b border-gray-200">
              {[...Array(8)].map((_, colIndex) => (
                <td key={colIndex} className="py-4 px-6">
                  <div className="h-4 bg-gray-200 rounded"></div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export const EmptyState = ({ title, description, actionButton }) => (
  <div className="bg-white shadow-lg rounded-xl p-12 text-center">
    <svg
      className="mx-auto h-24 w-24 text-gray-400 mb-4"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1}
        d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
      />
    </svg>
    <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
    <p className="text-gray-600 mb-6">{description}</p>
    {actionButton}
  </div>
);

export const ErrorState = ({ title, message, onRetry }) => (
  <div className="bg-white shadow-lg rounded-xl p-12 text-center">
    <svg
      className="mx-auto h-24 w-24 text-red-400 mb-4"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1}
        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
    <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
    <p className="text-gray-600 mb-6">{message}</p>
    <button
      onClick={onRetry}
      className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-medium transition transform hover:scale-105"
    >
      Reintentar
    </button>
  </div>
);
